import { api } from "api/api";
import { AxiosError } from "axios";
import Acao from "model/administracao/cadastro/Acao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Deposito from "model/suprimentos/Deposito";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class DepositoService implements BaseServiceCadastros<Deposito> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/deposito/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: string | number) {
        return new Promise<Deposito>((resolve, reject): void => {
            api
                .get(`/deposito/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(deposito: Deposito) {
        return new Promise<Deposito>((resolve, reject): void => {
            let url = `/deposito/incluir`;
            api
                .post(url, JSON.stringify(deposito))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(deposito: Deposito) {
        return new Promise<Deposito>((resolve, reject): void => {
            api
                .put(`/deposito/editar`, JSON.stringify(deposito))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: string | number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/deposito/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }


}

export default DepositoService;
